export default __webpack_public_path__ + "static/media/air-cooling.7981120b.png";